export default "__VITE_ASSET__CjSqoFjj__"